/**
 * @file Horloge systeme (implemente WallClock du core), detection de visibilite d'onglet / fermeture, infos appareil.
 */
import type { WallClock } from '@core/Clock';

export class SystemClock implements WallClock {
  nowMs(): number {
    return Date.now();
  }
}

export interface VisibilityHandlers {
  onHidden(): void;
  onVisible(): void;
}

/** Abonne aux changements de visibilite + pagehide ; retourne la fonction de desabonnement. */
export const watchVisibility = (h: VisibilityHandlers): (() => void) => {
  const onVis = (): void => (document.visibilityState === 'hidden' ? h.onHidden() : h.onVisible());
  const onHide = (): void => h.onHidden();
  document.addEventListener('visibilitychange', onVis);
  window.addEventListener('pagehide', onHide);
  return () => {
    document.removeEventListener('visibilitychange', onVis);
    window.removeEventListener('pagehide', onHide);
  };
};

export const isTouchDevice = (): boolean => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

export const devicePixelRatio = (cap: number): number => Math.min(cap, window.devicePixelRatio || 1);

export const vibrate = (ms: number, enabled: boolean): void => {
  if (enabled && 'vibrate' in navigator) navigator.vibrate(ms);
};

/** Identifiant aleatoire (non deterministe : uniquement pour playerId/deviceId, jamais dans la simulation). */
export const randomId = (prefix: string): string => {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return prefix + Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};

export const randomSeed = (): number => {
  const a = new Uint32Array(1);
  crypto.getRandomValues(a);
  return a[0] ?? 1;
};
